<div *ngFor="let toast of toastService.toasts" class="alert celerity-toast" [class]="toast.className">
  {{toast.message}}
  <button (click)="toastService.remove(toast)" type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>

</div>
